module.exports = __webpack_public_path__ + "img/29-02.2b117891.png";